module.exports = __webpack_public_path__ + "images/st_patricks_dir_banner_timer-dfb799e7727f3ca7eacc0eb121051422.jpg";